import Vue from 'vue'
import Router from 'vue-router'
import common from './common/common.js'

const Login = () => import('./views/login/login.vue')
const Layer = () => import('./views/layer/layer.vue')
const Home = () => import('./views/home/index.vue')
const ConfigManage = () => import('./views/configManage/index.vue')
const RolesManage = () => import('./views/rolesManage/index.vue')
const PermissionsManage = () => import('./views/permissionsManage/index.vue')
const UsersManage = () => import('./views/usersManage/index.vue')
const Emp = () => import('./views/emp/index.vue')
const OrderManage = () => import('./views/orderManage/index.vue')
const RetrievePwd = () => import('./views/retrievePwd/index.vue')
const Cate = () => import('./views/cate/index.vue')
const Source = () => import('./views/source/index.vue')

const Section = () => import('./views/sectionManage/index.vue')
const Position = () => import('./views/position/index.vue')
const Order = () => import('./views/order/index.vue')
const Article = () => import('./views/article/index.vue')
const ArticleCate = () => import('./views/articleCate/index.vue')
const Msg = () => import('./views/msg/index.vue')

const TestResultManage = () => import('./views/testResultManage/index.vue')
const AskQuestionManage = () => import('./views/askQuestionManage/index.vue')
const AskManage = () => import('./views/askManage/index.vue')
const MemberManage = () => import('./views/memberManage/index.vue')
const ExamQuestionManage = () => import('./views/examQuestionManage/index.vue')
const PointsGoodsManage = () => import('./views/pointsGoodsManage/index.vue')
const AskResultManage = () => import('./views/askResultManage/index.vue')
const VedioManage = () => import('./views/vedioManage/index.vue')
const ExamManage = () => import('./views/examManage/index.vue')
const SchoolManage = () => import('./views/schoolManage/index.vue')
const SchoolClassManage = () => import('./views/schoolClassManage/index.vue')

const TVideos = () => import("./views/t/videos")
const Bank = () => import("./views/bank/index")

Vue.use(Router)

const router = new Router({
    routes: [
        {//layer
            path: '/',
            component: Layer,
            children: [
                {//主页
                    path: '/',
                    name: 'home',
                    component: Home,
                },
                {//系统配置管理
                    path: '/configManage',
                    name: 'configManage',
                    component: ConfigManage
                },
                {//系统角色管理
                    path: '/rolesManage',
                    name: 'rolesManage',
                    component: RolesManage
                },
                {//系统权限管理
                    path: '/permissionsManage',
                    name: 'permissionsManage',
                    component: PermissionsManage
                },
                {//系统用户管理
                    path: '/usersManage',
                    name: 'usersManage',
                    component: UsersManage
                },
                {//系统员工管理
                    path: '/emp',
                    name: 'emp',
                    component: Emp
                },
                {//资源分类
                    path: '/cate',
                    name: 'cate',
                    component: Cate
                },
                {//资源
                    path: '/source',
                    name: 'source',
                    component: Source
                },
                {//部门管理
                    path: '/section',
                    name: 'section',
                    component: Section
                },
                {//广告位管理管理
                    path: '/position',
                    name: 'position',
                    component: Position
                },
                {//提单管理
                    path: '/order',
                    name: 'order',
                    component: Order
                },
                {//文章管理
                    path: '/article',
                    name: 'article',
                    component: Article
                },
                {//文章分类管理
                    path: '/articleCate',
                    name: 'articleCate',
                    component: ArticleCate
                },
                {//公告管理
                    path: '/msg',
                    name: 'msg',
                    component: Msg
                },
                {// 测试结果管理
                    path: '/testResultManage',
                    name: 'testResultManage',
                    component: TestResultManage
                },
                {// 问券问题管理
                    path: '/askQuestionManage',
                    name: 'askQuestionManage',
                    component: AskQuestionManage
                },
                {// 问券管理
                    path: '/askManage',
                    name: 'askManage',
                    component: AskManage
                },
                {// 会员管理
                    path: '/memberManage',
                    name: 'memberManage',
                    component: MemberManage
                },
                {// 试卷题目管理
                    path: '/examQuestionManage',
                    name: 'examQuestionManage',
                    component: ExamQuestionManage
                },
                {// 积分商品管理
                    path: '/pointsGoodsManage',
                    name: 'pointsGoodsManage',
                    component: PointsGoodsManage
                },
                {// 问卷结果管理
                    path: '/askResultManage',
                    name: 'askResultManage',
                    component: AskResultManage
                },
                {// 视频管理
                    path: '/vedioManage',
                    name: 'vedioManage',
                    component: VedioManage
                },
                {// 订单管理
                    path: '/orderManage',
                    name: 'orderManage',
                    component: OrderManage
                },
                {// 试卷管理
                    path: '/examManage',
                    name: 'examManage',
                    component: ExamManage
                },
                {// 学校管理
                    path: '/schoolManage',
                    name: 'schoolManage',
                    component: SchoolManage
                },
                {// 班级管理
                    path: '/schoolClassManage',
                    name: 'schoolClassManage',
                    component: SchoolClassManage
                },
                {
                    path: "/t/videos",
                    name: "tVideos",
                    component: TVideos
                },

                {// 银行管理
                    path: "/bank",
                    name: "bank",
                    component: Bank
                }
            ]
        },
        {//登录页
            path: '/login',
            name: 'login',
            component: Login
        },
        {//找回密码页
            path: '/retrievePwd',
            name: 'retrievePwd',
            component: RetrievePwd
        },

    ]
})

//路由前先验证token
router.beforeEach((to, from, next) => {
    window.nowUrlName = to.name;

    let valiToken = common.getToken();

    if (to.path == '/login' && valiToken != false) {
        next({path: '/'})
    }

    if (valiToken == false && to.path != '/login' && to.path != '/retrievePwd') {
        next({path: '/login'});
    }

    next();

})
export default router
